import $ from 'jquery'

export function toHtml(domId) {
  let html = '<html lang="zh-cmn-Hans" class=" ">'
  //头部样式 太大了 需要1.2M 先不保存
  html +=  $('head')[0].innerHTML
  //调整页面样式，修复打印多出空白页问题
  var nod = document.createElement('style')
  var str = 'body{border:1px solid white;width:100%}';
  nod.appendChild(document.createTextNode(str))
  $('head')[0].appendChild(nod);
  //1. 内容
  let cloneContent = $('#' + domId).clone()
  //1.1 input框处理 回显值 不可编辑
  let inputArray = cloneContent.find('input')
  for (let i = 0; i < inputArray.length; i++) {
    $(inputArray[i]).attr('value', inputArray[i].value)
    $(inputArray[i]).attr('disabled', 'true')
  }
  //1.2 富文本框处理 隐藏工具栏 内容不可编辑
  cloneContent.find('.fr-toolbar').remove()
  cloneContent.find('.fr-element.fr-view').attr('contenteditable','false')

  //修复富文本内容回显
  let iframe = cloneContent.find('iframe')
  if (iframe.length != 0){
    let iframeId = document.querySelector('iframe').getAttribute("id");
    iframe[0].src = 'data:text/html;charset=utf-8,' + encodeURIComponent(
      "<!doctype html>" +
      "<html>" +
      "<head>" + document.getElementById(iframeId).contentWindow.document.head.innerHTML + "</head>" +
      "<body>" + document.getElementById(iframeId).contentWindow.document.body.innerHTML + "</body>" +
      "</html>"
    );
  }

  html += cloneContent.prop('outerHTML')
  //结尾
  html += '</html>'
  var r=new RegExp("<script.*src.*></script>","igm");
  var r1=new RegExp("<link href=.*rel=\"prefetch\">","igm");
  var r2=new RegExp("<link href=.*rel=\"preload\" as=\"script\">","igm");
  var r3=new RegExp("<link rel=\"icon\" href=.*\">","igm");
  html = html.replace(r," ");
  html = html.replace(r1," ");
  html = html.replace(r2," ");
  html = html.replace(r3," ");
  cloneContent.remove()
  return html
}

//通用模板（中标结果），样式回显调整
export function toUHtml(domId) {
  let html = '<html lang="zh-cmn-Hans" class=" ">'
  //1. 内容
  let cloneContent = $('#' + domId).clone()
  //1.1 input换成u
  let inputArray = cloneContent.find('input')
  for (let i = 0; i < inputArray.length; i++) {
    let uNode = $("<u>"+ inputArray[i].value+"</u>")
    $(inputArray[i]).replaceWith(uNode)
    // $(inputArray[i]).attr('value', inputArray[i].value)
    // $(inputArray[i]).attr('disabled', 'true')
  }
  // ant-calendar-picker-input ant-input
  cloneContent.find('.ant-calendar-picker-input.ant-input').attr('class','')
  //1.2 富文本框处理 隐藏工具栏 内容不可编辑
  cloneContent.find('.fr-toolbar').remove()
  cloneContent.find('.fr-element.fr-view').attr('contenteditable','false')

  html += cloneContent.prop('outerHTML')
  //结尾
  html += '</html>'
  cloneContent.remove()
  return html
}